import { Component, Input } from '@angular/core';
import { Utilisateur } from '../../../../utilisateur/models/utilisateur';
import { Nullable } from '../../../types';
import { MAIN_MENU, MenuItem } from '../../../menus/main-menu';
import { environment } from '@perval/shared';
import { CommonModule } from '@angular/common';
import { IconsModule } from '../../icons/icons.module';
import { RouterLink } from '@angular/router';
import { HasAccessDirective } from '../../../directives/has-access.directive';

@Component({
  selector: 'p-main-menu',
  standalone: true,
  imports: [CommonModule, HasAccessDirective, IconsModule, RouterLink],
  templateUrl: './p-main-menu.component.html',
  styleUrl: './p-main-menu.component.scss',
})
export class PMainMenuComponent {
  @Input() currentUser!: Utilisateur;
  @Input() isUserInfoDisplayed = false;
  @Input() isUserAuthenticated = false;

  activeItem: Nullable<MenuItem> = null;
  routeActiveItem: Nullable<MenuItem> = null;

  readonly MENU = MAIN_MENU;

  public goHome(): void {
    window.location.href = `${environment.host}/content/accueil`;
  }
}
